
//设置商品
export const SET_WARES = "SET_WARES";
//获取提交的采购单号列表
export const GET_PURCHASE_ORDER_NUMBER = "GET_PURCHASE_ORDER_NUMBER";
// 设置提交的采购单号列表
export const SET_PURCHASE_ORDER_NUMBER = "SET_PURCHASE_ORDER_NUMBER";
// 设置提交成功的订单号列表
export const SET_SUCCESS_ORDER_LIST = "SET_SUCCESS_ORDER_LIST";
// 设置采购单提交信息
export const SET_CONFIRM_MSG = "SET_CONFIRM_MSG";
// 设置错误信息列表
export const SET_ERR_LIST = 'SET_ERR_LIST';
// 设置是否有错误
export const SET_HAS_ERR = 'SET_HAS_ERR';
// 检查下单商品是否有中小件（全部大件）
export const CHECK_IS_OVERSIZED_GOODS = 'CHECK_IS_OVERSIZED_GOODS';
// 修改公司名称
export const SET_COMPANY_NAME = 'SET_COMPANY_NAME';
// 修改单位税号
export const SET_TAXPAYER_NUM = 'SET_TAXPAYER_NUM';
// 获取履约信息
export const GET_CALENDAR_INFO = 'GET_CALENDAR_INFO';


// WEBPACK FOOTER //
// ./src/store/confirm/type.js